import React from 'react'
const UserImportList = ({list}) => {

    return ( 
        <>
        <div className="row course-list list m-1"> 
        {list && list.length > 0 && list.map((item,index) => {
            return (
            <div className="row card text-dark p-0 mb-2 me-3  col-xs-12 col-sm-3 col-lg-3"  key={index}>
<div className="row no-gutters align-items-center justify-content-left">
            <div className="col-auto text-center mb-2 p-1 text-center">
              <img
                src={"https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID="+item.employeeid + "&size=320"}
                className="rounded-circle me-1"
                data-toggle="tooltip"
                data-placement="bottom"
                title=""
                alt=""
                style={{
                  maxHeight: "100px",
                  Width: "100%",
                  maxWidth: "100px",
                }}
              ></img>
            </div>

            <div className="col-auto ms-2">
            <span className='badge rounded-pill bg-danger'>
                 {item.employeeid} 
                
                 </span>
              <div className="card-body p-1">
                <div className="card-text">
                  <h6
                    className="card-title d-inline me-2 badge badge-danger"
                    style={{ fontSize: "14px" }}
                  >
                 
                  
                  
                  </h6>
                </div>                         
              </div>
            </div>
          </div>
            </div>
                )
        } )}
          </div>
        </>
     );
}
 
export default UserImportList;